
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LuckinsItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"luckinsItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"otherDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catalogueNumber1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catalogueNumber2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edpNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commodityCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vatRateCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stockUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"splitPackPrice"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceBreakQuantity"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tradePrice1"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceBreakQuantity"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tradePrice2"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceBreakQuantity"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tradePrice3"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceBreakQuantity"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tradePrice4"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceBreakQuantity"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productRangeMajor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productRangeMinor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productRangeCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commodityMajor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commodityMinor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brandName"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":733}};
    doc.loc.source = {"body":"query LuckinsItem($id: Long) {\n  data: luckinsItem(id: $id) {\n    id\n    uuid\n    concurrencyVersion\n    itemCode\n    shortDescription\n    otherDescription\n    catalogueNumber1\n    catalogueNumber2\n    edpNumber\n    commodityCode\n    vatRateCode\n    priceUnit\n    stockUnit\n    splitPackPrice {\n      price\n      priceBreakQuantity\n    }\n    tradePrice1 {\n      price\n      priceBreakQuantity\n    }\n    tradePrice2 {\n      price\n      priceBreakQuantity\n    }\n    tradePrice3 {\n      price\n      priceBreakQuantity\n    }\n    tradePrice4 {\n      price\n      priceBreakQuantity\n    }\n    supplierCode\n    productRangeMajor\n    productRangeMinor\n    productRangeCode\n    commodityMajor\n    commodityMinor\n    status\n    brandName\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["LuckinsItem"] = oneQuery(doc, "LuckinsItem");
        
